import React, {Component} from 'react';

import {ICON_TYPES} from './constants';
import {CheckmarkIcon, CloseIcon, CheckmarkIconWrapper, CloseIconWrapper, IconsWrapper, FadeOutEffect} from './styles';

class ChecklistIndicatorIcons extends Component {
  render() {
    const {size, position} = this.props;

    return (
      <IconsWrapper position={position}>
        <FadeOutEffect size={size} />
        <CheckmarkIconWrapper size={size}>
          <CheckmarkIcon size={size} name={ICON_TYPES.CHECKMARK} />
        </CheckmarkIconWrapper>
        <CloseIconWrapper size={size}>
          <CloseIcon size={size} name={ICON_TYPES.CLOSE} />
        </CloseIconWrapper>
      </IconsWrapper>
    );
  }
}

export default ChecklistIndicatorIcons;
